import { Injectable, inject } from '@angular/core';
import { IntegrationIReckonHotelsAndUnitsService } from '@era/locations-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import {
  IReckonIntegrationContainerActions,
  IReckonIntegrationResolverActions,
  IntegrationApiActions,
} from './integrated-ireckon-room.actions';

@Injectable()
export class IntegratedIReckonRoomEffects {
  private readonly actions$ = inject(Actions);
  private readonly api = inject(IntegrationIReckonHotelsAndUnitsService);

  integrationsLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IReckonIntegrationResolverActions.iReckonIntegrationRequested),
      mergeMap(({ roomUniqueId }) =>
        safeMap(
          this.api.getIntegratedIReckonRooms({
            hotelCode: undefined,
            unitCode: undefined,
            locationUniqueId: undefined,
            roomUniqueId,
          }),
          (rooms) => IntegrationApiActions.iReckonIntegrationsLoaded({ rooms }),
          (error) => IntegrationApiActions.iReckonIntegrationsLoadedError({ error })
        )
      )
    );
  });

  integrationUpdateEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IReckonIntegrationContainerActions.iReckonIntegrationUpdated),
      mergeMap(({ room }) =>
        room.id // existing room
          ? safeMap(
              this.api.updateIntegratedIReckonRoom({ integratedRoomId: room.id, integratedIReckonRoom: room }),
              () => IntegrationApiActions.iReckonIntegrationUpdated({ room }),
              (error) => IntegrationApiActions.iReckonIntegrationUpdatedError({ room, error })
            )
          : safeMap(
              this.api.addIntegratedIReckonRoom({ integratedIReckonRoomAdd: room }),
              () => IntegrationApiActions.iReckonIntegrationAdded({ room }),
              (error) => IntegrationApiActions.iReckonIntegrationAddedError({ room, error })
            )
      )
    );
  });

  integrationDeletedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IReckonIntegrationContainerActions.iReckonIntegrationDeleted),
      mergeMap(({ room }) =>
        safeMap(
          this.api.deleteIntegratedIReckonRoom({ integratedRoomId: room.id }),
          () => IntegrationApiActions.iReckonIntegrationDeleted({ room }),
          (error) => IntegrationApiActions.iReckonIntegrationDeletedError({ room, error })
        )
      )
    );
  });
}
